import { useFedStore } from '../store';
import { Ic } from '../icons';
import heroes from '../assets/home-2026/heroes.webp';

const COPY = {
  ru: {
    signal: 'Сигнал потерян',
    title: 'Страница вне сетки',
    text: 'Похоже, этот адрес больше не участвует в турнире. Вернись на главную арену или сразу открой актуальные соревнования.',
    home: 'На главную',
    tournaments: 'Смотреть турниры',
    code: 'Ошибка маршрута · СКО',
  },
  kz: {
    signal: 'Сигнал жоғалды',
    title: 'Парақша желіден тыс',
    text: 'Бұл мекенжай енді турнирге қатыспайтын сияқты. Басты аренаға орал немесе қазіргі жарыстарды бірден аш.',
    home: 'Басты бетке',
    tournaments: 'Турнирлерді көру',
    code: 'Бағыт қатесі · СҚО',
  },
};

export default function FedNotFound() {
  const { go, lang } = useFedStore();
  const copy = COPY[lang === 'kz' ? 'kz' : 'ru'];

  return (
    <section className="fed-404" aria-labelledby="fed-404-title">
      <div className="fed-404-grid" aria-hidden="true" />
      <div className="fed-404-scan" aria-hidden="true" />
      <div className="fed-404-inner">
        <div className="fed-404-copy">
          <span className="fed-404-status"><i />{copy.signal}</span>
          <div className="fed-404-code" aria-label="Ошибка 404">
            <span>4</span><span className="fed-404-zero">0</span><span>4</span>
          </div>
          <span className="fed-404-meta">{copy.code}</span>
          <h1 id="fed-404-title">{copy.title}</h1>
          <p>{copy.text}</p>
          <div className="fed-404-actions">
            <button className="primary" onClick={() => go('home')}><Ic name="home" size={20} />{copy.home}</button>
            <button onClick={() => go('tournaments')}>{copy.tournaments}<Ic name="chevR" size={20} /></button>
          </div>
        </div>
        <div className="fed-404-art" aria-hidden="true">
          <div className="fed-404-ring"><b>404</b><span>NO SIGNAL</span></div>
          <img src={heroes} alt="" />
        </div>
      </div>
      <div className="fed-404-ticker" aria-hidden="true">
        <span>ERROR 404 · PAGE OUT OF BRACKET · RETURN TO ARENA · ERROR 404 · PAGE OUT OF BRACKET · RETURN TO ARENA ·</span>
      </div>
    </section>
  );
}
